import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { UniversalImporterItAssetsModalPageDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { trackingEvents } from 'modules/core/lib/Tracking/events'
import { track } from 'modules/core/lib/Tracking/tracker'
import i18n from 'modules/core/lib/i18n'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterItAssetsModalPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { data, error } = useQuery(UniversalImporterItAssetsModalPageDocument, {
    fetchPolicy: 'network-only',
  })

  const canImportResources = true // data?.universalImporter?._policies.importResources.can

  const onClose = () => {
    navigate(navigation.it_management.fullPath())
  }

  if (data && (error || !canImportResources)) {
    navigate(navigation.it_management.fullPath())
    return null
  }

  if (!data || !canImportResources) {
    return null
  }

  const onUploadedFile = (_file: File) => {
    track(trackingEvents.itManagement.importAssets.addFile)
  }

  const onCompleted = () => {
    track(trackingEvents.itManagement.importAssets.userCompleteTheImport)
  }

  const onError = (error_message?: string) => {
    track(trackingEvents.itManagement.importAssets.error, {
      action_type: 'import',
      error_message,
    })
  }

  return (
    <Modal
      illustration="table-file"
      title={i18n.t('it_management.assets_import_modal.title')}
      onClose={onClose}
      disableFocusTrap
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
        </Box>
      }
    >
      <NuvoImporter
        importType="it_management_it_assets_importer"
        locale={locale}
        companyId={company.id}
        onUploadedFile={onUploadedFile}
        onCompleted={onCompleted}
        onError={onError}
      />
    </Modal>
  )
}

export default UniversalImporterItAssetsModalPage
